import React, { useEffect } from 'react'
import { OptionModel } from '../common/types/OptionModel';
import { useDispatch } from 'react-redux';
import { ThunkDispatch } from 'redux-thunk';
import commonNetwork from '../common/api/commonNetwork';

const useGetUserTypes = (
    setUserTypesOptions: (options: OptionModel[]) => void,
    setUserTypeLoading: (loading: boolean) => void,
) => {
    const dispatch = useDispatch<ThunkDispatch<any, any, any>>();

    useEffect(() => {
        const fetchUserTypes = async () => {
            try {
                setUserTypeLoading(true);
                const resultActions = await commonNetwork.get("/user/get-user-types");
                if (resultActions.data.length > 0) {
                    const userTypesData = resultActions.data;
                    const options: OptionModel[] = userTypesData.map((item: any) => ({
                        value: item.id,
                        label: item.label
                    }));
                    setUserTypesOptions(options);
                }
            } catch (error) {

            } finally{
                setUserTypeLoading(false);
            }
        }
        fetchUserTypes();
    }, [dispatch])
}

export default useGetUserTypes;